<template>
  <div class="integral">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"
    >
      <div v-if="list.length > 0" class="list">
        <ul>
          <li v-for="(item, index) of list" :key="index">
            <div class="left">
              <p>{{item.title}}</p>
              <b>{{item.time}}</b>
            </div>
            <span class="redSpan" v-if="item.type === '2'">
              -{{item.num}}
            </span>
            <span class="greenSpan" v-if="item.type === '1'">
              +{{item.num}}
            </span>
          </li>
        </ul>
      </div>
    </Scroller>
    <!--<footer v-if="list.length > 0">-->
    <!--<p>积分明细只保留最近6个月<br/>更多明细请<span @click="keFu">联系客服</span></p>-->
    <!--</footer>-->
    <div class="rules" @click="ruleClick">
      <img src="../../assets/images/integralruletegs.png">
    </div>
    <empty :isOpenSign="openSign" :path="'integralSub'" v-if="empty"></empty>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
export default {
  name: 'integralDetails',
  components: {
    empty,
    Scroller
  },
  data () {
    return {
      list: [],
      openSign: this.$route.query.isOpenSign ? this.$route.query.isOpenSign : '',
      empty: false, // 判断header DOM元素是否显示
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '——我是有底线的——'
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'integraldetails'})
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/Integral/getIntegral?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.list = res.data.integrallist
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.integrallist)
          }
          that.loading = false
          if (res.data.integrallist.length < that.pagesize) {
            that.finished = true
            if (that.list && that.list.length <= 0) {
              that.empty = true
            } else {
              that.empty = false
            }
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      // this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    ruleClick: function () {
      this.$router.push('/integralrule')
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .integral {
    /*background: #fff;*/
    .my_scroller {
      position: relative;
      z-index: 10;
      /*background: #fff;*/
      margin-bottom: 0.1rem;
    }
    .list {
      /*background: #fff;*/
      ul {
        li {
          background: #fff;
          position: relative;
          padding:0.17rem 0.11rem 0;
          margin: 0.1rem 0.11rem 0;
          border-radius: 0.04rem;
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          display: -o-flex;
          justify-content: space-between;
          -moz-justify-content: space-between;
          -ms-justify-content: space-between;
          -webkit-justify-content: space-between;
          -o-justify-content: space-between;
          align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          .left {
            padding-bottom: 0.06rem;
            margin-right: 0.16rem;
            /*border-bottom: 1px solid #EFEFEF;*/
            flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            p {
              font-size:0.13rem;
              font-weight:400;
              color:rgba(68,68,68,1);
              line-height:0.18rem;
              margin-bottom: 0.04rem;
            }
            b {
              display: block;
              font-size:0.1rem;
              font-weight:600;
              color:rgba(180,180,180,1);
              line-height:0.14rem;
            }
          }
          span {
            font-size:0.14rem;
            font-weight:600;
            line-height:0.2rem;
            position: absolute;
            right: 0.11rem;
            &.redSpan {
              color:rgba(210,53,53,1);
            }
            &.greenSpan {
              color:rgba(53,210,144,1);
            }
          }
        }
      }
    }
    footer {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0.06rem;
      margin-top: 0.8rem;
      p {
        font-size:0.1rem;
        font-weight:400;
        color:rgba(208,209,212,1);
        line-height:0.14rem;
        text-align: center;
        span{
          color: #4A90E2;
        }
      }
    }
    .rules{
      position: fixed;
      top: 0.46rem;
      right: 0;
      z-index: 10;
      img {
        width: 0.84rem;
        height: 0.52rem;
      }
    }
  }
</style>
<style lang="scss">
  .integral {
    .van-icon-play {
      float: left !important;
      line-height:0.25rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/integral/integralDetails.vue